import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// v3/event_create endpoint
//    accepts the event fields AND a required gamesettings field/struct on the payload.
//    create the v3game_settings
//    create the v3event with the newly created game_settings_id
// v3/event_get endpoint
//    takes id, returns the event with gamesettings
// v3/event_list endpoint
//    need to think about this one.
// v3/event_leaderboard_list
//    takes event id, returns the leaderboard scores for the even

// @ Create Apex Event
export const apexEventCreate = async (payload) => {
  console.log('apex event create payload:', payload);
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_create`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Get Single Apex event details
// @ field: event_id - this is the event id
export const apexEventGet = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List events from Connect and Apex with details
// @ User events that they have played or can play
// @ uses user auth token
export const apexUserEventList = async (timeline) => {
  let response = {};
  try {
    response = await axiosInstanceCached.post(`/event_list`, {
      id: `apex_user_event_list_${timeline}`,
      cache: {
        ttl: 1000 * 60 * 5, // 5 minutes
      },
    });

    // console.log('apex_user_event_list response:', response);
    // console.log('apex_user_event_list cached:', response.cached);
    // console.log('apex_user_event_list ttl:', response.config?.cache?.ttl);
    // console.log('apex_user_event_list config:', response.config);
    // console.log('apex_user_event_list duration:', response.duration);
    // console.log('============================');

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List clubhouse events from Connect and Apex with details
// @ payload "clubhouse_id"
export const apexClubhouseEventList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/event_list_clubhouse`, payload);
    // response = await axiosInstanceCached.post(`/v3/event_list`, {
    //   id: `apex_clubhouse_event_list_${timeline}`,
    //   cache: {
    //     ttl: 1000 * 60 * 5, // 5 minutes
    //   },
    // });

    // response.data.forEach((event) => {
    //   if (event.timeline === 'past' && event.game === 'apex') {
    //     console.log('past and apex');
    //   } else if (event.timeline === 'past' && event.game === 'connect') {
    //     console.log('past and connect');
    //   }
    //   // console.log('===================');
    //   // console.log('payload', event.timeline);
    //   // console.log('game', event.game);
    //   // console.log('event game', event.name);
    //   // console.log('===================');
    // });

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List events leaderboard from Connect and Apex with details
// @ payload "event_id"
export const apexEventLeaderboard = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_leaderboard_get`, payload);
    // response = await axiosInstanceCached.post(`/v3/event_list`, {
    //   id: `apex_user_event_list_${timeline}`,
    //   cache: {
    //     ttl: 1000 * 60 * 5, // 5 minutes
    //   },
    // });

    // console.log('apex_user_event_list response:', response);
    // console.log('apex_user_event_list cached:', response.cached);
    // console.log('apex_user_event_list ttl:', response.config?.cache?.ttl);
    // console.log('apex_user_event_list config:', response.config);
    // console.log('apex_user_event_list duration:', response.duration);
    // console.log('============================');

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Update apex event to change status
// @ payload id of event and full event object
// @ only change status to disabled or published
export const apexEventUpdate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_update`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List custom commentary options
export const apexEventSurveyList = async () => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_survey_list`);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Check Apex event user eligibility
// @ field: event_id - this is the event id OR
// @ field: event_code - this is the event code
// @ field: user_ids - array of user ID strings
export const apexEventEligible = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_eligible`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
